import React from 'react'

function QCRLogoMark({ size = 20, color = '#8a6231' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className="flex-none block">
      <path d="M4.4 12a7.6 7.6 0 1 0 2.6-5.75" stroke={color} strokeWidth="2.1" strokeLinecap="round" />
      <path d="M3.5 4.6v4.2h4.2" stroke={color} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M12 8.1V12l-2.7 2.1" stroke={color} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default QCRLogoMark
